import { create } from 'zustand';

import { EReviewIncidenceType } from '@/types';

type TReportState = {
  report: boolean;
  reportedId: string;
  reportType: 'program' | 'segment' | 'clip';
  reportEditData: {
    reviewed_by_user_id?: string;
    review_incidence_type?: EReviewIncidenceType;
    review_incidence_note?: string;
  } | null;
  setReportedId: (id: string) => void;
  setReport: (report: boolean) => void;
  setReportType: (type: 'program' | 'segment' | 'clip') => void;
  setReportEditData: (
    data: {
      reviewed_by_user_id?: string;
      review_incidence_type?: EReviewIncidenceType;
      review_incidence_note?: string;
    } | null
  ) => void;
};

export const useReport = create<TReportState>(set => ({
  report: false,
  reportedId: '',
  reportType: 'program',
  reportEditData: {},
  setReportedId: id => set({ reportedId: id }),
  setReport: report => set({ report }),
  setReportType: type => set({ reportType: type }),
  setReportEditData: data => set({ reportEditData: data }),
}));
